import type { PaymentProviderAccount } from "schemas/generated/paymentProvider";
import type { AutomaticTaxStatus } from "schemas/paymentProvider";
import type { RequestFn } from "./request";

export function createPaymentProviderAccountClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    setUp: ({ projectId }: { projectId: string }) => {
      return request<{ onboardingUrl: string }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/setup`,
      });
    },
    createFinishSetupLink: ({ projectId }: { projectId: string }) => {
      return request<{ url: string }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/finish-setup-link`,
      });
    },
    createDashboardLink: ({ projectId }: { projectId: string }) => {
      return request<{ url: string }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/dashboard-link`,
      });
    },
    getAccount: ({ projectId }: { projectId: string }) => {
      return request<{ account: PaymentProviderAccount | null }>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/payment-provider-account`,
      });
    },
    getTaxStatus: ({ projectId }: { projectId: string }) => {
      return request<{ taxStatus: AutomaticTaxStatus }>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/payment-provider-account/tax-status`,
      });
    },
    disconnect: ({ projectId }: { projectId: string }) => {
      return request<{ success: boolean }>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/payment-provider-account/disconnect`,
      });
    },
  };
}
